import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["unread"]

  async unreadTargetConnected(el) {
    const lastViewedTimestamp = parseInt(localStorage.getItem('lastViewedChangelogDate'), 10) || 0
    const latestTimestamp = await this.getLatestTimestamp()

    console.log('latestTimestamp', latestTimestamp)
    console.log('lastViewedTimestamp', lastViewedTimestamp)

    if (latestTimestamp > lastViewedTimestamp) {
      el.classList.remove('hidden')
    } else {
      el.classList.add('hidden')
    }
  }

  async getLatestTimestamp() {
    const response = await fetch('http://localhost:3001/announcements', {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    const data = await response.json();
    return data.announcements[0].published_at;
  }

  markAsViewed() {
    localStorage.setItem('lastViewedChangelogDate', this.latestDateValue.toString())
    this.unreadTargets.forEach(target => target.classList.remove('hidden'))
  }
}
